/*
 * TODO so i removed most of the code that deals directly with grids. This
 * should be spit up further. General filter management should be separate from
 * the brand psecific stuff like opening and closing menus.
 */
// eslint-ignore-next-line complexity
(function ($) {
  var FilterSetManager = function ($template) {
    this.$template = $template;
    this.savedDivTag = {};
    $template.data('filter-set-manager', this);
    $template.attr('data-filter-manager-element', 1);
    this.filterManifest = null;
    this.filterMap = {};
  };

  FilterSetManager.getManager = function ($template) {
    var manager = $template.data('filter-set-manager');

    if (!manager) {
      $template = $template.closest('[data-filter-manager-element]');
      manager = $template.data('filter-set-manager');
    }

    return manager;
  };

  FilterSetManager.prototype.renderCategory = function (category, all_filter_sets) {
    var self = this;
    var $template = this.$template;
    var namespace = category.key;
    var filter_list = category.filter_list;
    var $filter_set_container = $('.js-mpp-filter-set__category[data-filter-key="' + namespace + '"]', $template);
    // if over 10 tags. limit to tags with at least 4 items
    var threshold = 0;

    _.each(filter_list, function (filter_obj) {
      var tag_key = filter_obj.key;
      var tag_data = all_filter_sets[namespace][tag_key];

      // means no items matched
      if (!tag_data) {
        return;
      }

      // minimum threshold
      if (tag_data.count < threshold) {
        return;
      }

      var filter_key = tag_data['filter_key'];

      self.savedDivTag[filter_key] = true;

      var data = {
        label: tag_data.name,
        namespace: namespace,
        key: tag_key,
        filter_key: filter_key,
        classname: tag_data.classname
      };
      var rendered = site.template.get({
        name: 'filter_set_key',
        data: data
      });

      $('.js-mpp-filter-set__category-links', $filter_set_container).append(rendered);
    });
  };

  FilterSetManager.prototype.renderFilters = function (filter_manifest, all_filter_sets) {
    var self = this;

    // dynamically create filter buttons
    _.each(filter_manifest, function (category) {
      self.renderCategory(category, all_filter_sets);
    });

    var $filterButtons = this.getFilterButtons();

    // Loop through our filters and hide any without tags
    // since we dynamically create filter links, not sure this is still
    // needed
    $filterButtons.each(function (i, obj) {
      var $filter = $(obj);
      var filter_key = $filter.data('filter-key');

      if (self.savedDivTag[filter_key] !== true) {
        $filter.addClass('hidden');
      }
    });

    var $triggerSets = this.getTriggerSets();

    // if trigger set is empty. Hide it.
    $triggerSets.each(function (i, obj) {
      var $filter_set = $(obj);
      var $links = $('.js-mpp-filter-set__link:not(.hidden)', $filter_set);

      if ($links.length === 0) {
        $filter_set.hide();
      }
    });
  };

  FilterSetManager.prototype.getTriggerSets = function () {
    var $template = this.$template;
    var $triggerSets = $('.js-mpp-filter-set__category', $template);

    return $triggerSets;
  };

  FilterSetManager.prototype.getFilterButtons = function () {
    var $template = this.$template;
    var $filterButtons = $('.js-mpp-filter-set__link', $template);

    return $filterButtons;
  };

  FilterSetManager.prototype.getFilterQuery = function () {
    var self = this;
    var $filterButtons = this.getFilterButtons();
    var filterQuery = {
      __type: 'AND'
    };
    var defaultGroup = {};
    var empty = true;

    $filterButtons.filter('.active').each(function () {
      var $filter = $(this);
      var filter_key = $filter.data('filter-key');
      var category = self.filterMap[filter_key];
      var parentGroup = filterQuery;

      // Due to TF intiially starting as OR. We allow the top levels to be OR
      // which means the top level OR groups act like they are in a single
      // group.
      if (category.set_type === 'OR') {
        parentGroup = defaultGroup;
      }

      if (typeof parentGroup[category.key] === 'undefined') {
        parentGroup[category.key] = {
          __type: 'OR'
        };
      }

      var group = parentGroup[category.key];

      group[filter_key] = true;
      empty = false;
    });

    if (!_.isEmpty(defaultGroup)) {
      defaultGroup.__type = 'OR';
      filterQuery['default'] = defaultGroup;
    }

    if (empty) {
      return {};
    }

    return filterQuery;
  };

  FilterSetManager.prototype.handleFilterClick = function ($filter) {
    var $template = this.$template;

    $filter.toggleClass('active');
    this.setActiveStates();

    var filterQuery = this.getFilterQuery();

    $template.trigger('filterset:filter-set', filterQuery);

    return filterQuery;
  };

  /*
   * Placeholder for handling derivative states. Like a per-category clear all
   * link.
   */
  FilterSetManager.prototype.setActiveStates = function () {};

  FilterSetManager.prototype.reset = function () {
    var $template = this.$template;
    var $filterButtons = this.getFilterButtons();

    $template.trigger('filterset:reset');
    $filterButtons.removeClass('active');
    this.setActiveStates();
  };

  FilterSetManager.prototype.getFilterManifest = function () {
    var self = this;

    if (self.filterManifest !== null) {
      return self.filterManifest;
    }

    var $triggerSets = self.getTriggerSets();
    var filter_manifest = {};

    $triggerSets.each(function (i, obj) {
      var $category = $(obj);
      var category = $category.data('filter-category');

      filter_manifest[category.key] = category;

      if (!_.isEmpty(category.filter_list)) {
        _.each(category.filter_list, function (filter) {
          var filter_key = category.key + '--' + filter.key;

          filter.filter_key = filter_key;
          self.filterMap[filter_key] = category;
        });
      }
    });

    self.filterManifest = filter_manifest;

    return filter_manifest;
  };

  Drupal.behaviors.mppFilterSetFormatterV1 = {
    attach: function (context) {
      var $templates = $('.js-mpp-filter-set-formatter--v1', context);

      $templates.each(function (i, obj) {
        var $template = $(obj);
        var filterManager = new FilterSetManager($template);

        $template.on('filterset:request-reset', function () {
          filterManager.reset();
        });

        /*
         * Allow external components to initialize the filterset.
         */
        $template.on('filterset:init', function (e, all_filter_sets) {
          var filter_manifest = $template.data('filter-manifest');

          if (_.isEmpty(all_filter_sets) || _.isNull(all_filter_sets)) {
            console.log('Product Grid did not return any filter set data. This is likely an error');

            return;
          }

          filterManager.renderFilters(filter_manifest, all_filter_sets);

          // init active states
          filterManager.setActiveStates();
        });
      });

      // roll up the cms built filterset into a manifest
      $templates.on('filterset:request-filter-manifest', function (e) {
        var $template = $(this);
        var filterManager = FilterSetManager.getManager($template);
        var filter_manifest = filterManager.getFilterManifest();

        $template.data('filter-manifest', filter_manifest);
        $template.trigger('filterset:filter-manifest', [filter_manifest]);

        return filter_manifest;
      });

      // handle filter link clicks
      $templates.on('click', '.js-mpp-filter-set__link', function (event) {
        event.preventDefault();
        var $filter = $(this);
        var filterManager = FilterSetManager.getManager($filter);

        filterManager.handleFilterClick($filter);
      });
    }
  };

  // separating out the ui parts
  Drupal.behaviors.filterUI = {
    attach: function (context) {
      var $templates = $('.js-mpp-filter-set-formatter--v1', context);

      $templates.each(function (i, obj) {
        var $template = $(obj);
        var $dropdownBtn = $('.js-mpp-filter-set__title', $template);
        var $closeDropdownBtn = $('.js-mpp-filter-set__close', $template);
        var $submitBtn = $('.js-mpp-filter-set__submit', $template);
        var $resetBtn = $('.js-mpp-filter-set__reset', $template);

        // Close dropdown
        function close() {
          $('.mpp-filter-set').removeClass('open');
          $('.mpp-filter-set__title').removeClass('open');
          $('.mpp-filter-set__body').hide();
          $(document).trigger('mpp-filter-set--close');
        }

        // Trigger filter results
        $submitBtn.on('click', function (event) {
          event.preventDefault();
          close();
        });

        $closeDropdownBtn.on('click', function (event) {
          event.preventDefault();
          close();
        });

        $resetBtn.on('click', function (event) {
          event.preventDefault();
          $template.trigger('filterset:request-reset');
        });

        // when we filter. show reset button
        $template.on('filterset:filter-set', function () {
          // Always show reset element once filtered
          $resetBtn.eq(0).addClass('mpp-filter-set__reset--show');
        });

        $template.on('mpp-filter-set--reset', function () {
          $resetBtn.eq(0).removeClass('mpp-filter-set__reset--show');
        });

        // Toggle dropdown
        $dropdownBtn.on('click', function (event) {
          event.preventDefault();
          $('.mpp-filter-set').toggleClass('open');
          $('.mpp-filter-set__title').toggleClass('open');
          $('.mpp-filter-set__body').toggle();

          if ($('.mpp-filter-set').hasClass('open')) {
            $(document).trigger('mpp-filter-set--open');
            $(document).on('mouseup.clickoutside touchend.clickoutside', function (e) {
              var container = $('.mpp-filter-set');

              // if the target of the click isn't the container nor a descendant of the container
              if (!container.is(e.target) && container.has(e.target).length === 0) {
                e.preventDefault();
                close();
                $(document).off('.clickoutside');
              }
            });
          } else {
            close();
            $(document).off('.clickoutside');
          }
        });
      });
    }
  };
})(jQuery);
